import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { API_BASE } from '@core/api';
import { authenticationInterceptor, OAUTH_CONFIG } from '@core/auth';
import { environment } from '@shared/environment';
import {
  PUSHER_CLIENT_FACTORY,
  PUSHER_CONFIG,
  PusherClientFactory,
} from '@shared/models';
import { NgxPermissionsModule } from 'ngx-permissions';
import Pusher from 'pusher-js';
import { appRoutes } from './app.routes';
import { PhotoStationMemoryService } from './pages/photo-station/photo-station-memory.service';
import { translationsSuffix } from './services/new-version/build-marker';
import { NewVersionReloadService } from './services/new-version/new-version-reload.service';
import { NewVersionService } from './services/new-version/new-version.service';
import { reloadOnFailedPageLoad } from './services/new-version/new-version.routing';

import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import deMessages from 'devextreme/localization/messages/de.json';
import { locale, loadMessages } from 'devextreme/localization';
import config from 'devextreme/core/config';

registerLocaleData(localeDe);
loadMessages(deMessages);
locale('de');
config({ defaultCurrency: 'EUR' });

const httpLoaderFactory = (
  http: HttpClient,
  versions: NewVersionService
): TranslateHttpLoader =>
  new TranslateHttpLoader(
    http,
    './i18n/',
    translationsSuffix(versions.ownMarker)
  );

const createPusherClient: PusherClientFactory = (key, options) =>
  new Pusher(key, options);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authenticationInterceptor])),
    // provideHttpClient(),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'de',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient, NewVersionService],
        },
      }),
    ]),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: API_BASE, useValue: environment.apiBase },
    { provide: OAUTH_CONFIG, useValue: environment.oauth },
    { provide: PUSHER_CONFIG, useValue: environment.pusher },
    { provide: PUSHER_CLIENT_FACTORY, useValue: createPusherClient },
    // {
    //   provide: NOTIFICATION_DURATION,
    //   useValue: { success: 3000, warning: 3000, error: 3000 },
    // },
    // { provide: APP_PERMISSIONS, useValue: appPermissions },
    // { provide: APP_ADMIN_PERMISSIONS, useValue: appAdminPermissions },
    provideRouter(
      appRoutes,
      withNavigationErrorHandler(reloadOnFailedPageLoad)
    ),
    // Built at start, whatever page loads first: it takes the tab id out of
    // session storage, so a tab duplicated later does not inherit it (RIEG-274).
    provideAppInitializer(() => {
      inject(PhotoStationMemoryService);
      inject(NewVersionService).start();
      inject(NewVersionReloadService).reloadIfHistoryRestoredOldBuild();
    }),
  ],
};
